<template>
  <v-container v-if="departingFlight!=null" :class="(isMobile? 'pl-0 pt-0 pb-0':'pl-0 pt-0 pb-0')">
      <v-card :flat="useFlatBorder">
          <v-card-title :class="isMobile?'pa-3':''"><h3 :style="'color:' + theme.primary.base"><v-icon :style="'color:inherit;'">flight_takeoff</v-icon> &nbsp;Flight details</h3></v-card-title>
          <v-card-text :class="isMobile?'pa-3':''">
            <table style="width:100%;">
              <tr><td colspan="2" style="font-weight:bold;">{{helper.dateAndTime.getDateText(departingFlight.origin.date)}}</td></tr>
              <tr>
                <td><span style="color:blue;font-weight:bold;">Airline: </span>{{departingFlight.airline + " (" + departingFlight.flightNo+")"}}</td>
              </tr>              
              <tr>
                <td>{{departingFlight.origin.airport.name + ' (' + departingFlight.origin.airport.code + ')'}}</td>
                <td style="text-align:right;">{{helper.dateAndTime.getFourDigitTimeWithColon(departingFlight.origin.time)}}</td>
              </tr>
              <tr>
                <td>{{departingFlight.destination.airport.name + ' (' + departingFlight.destination.airport.code + ')'}}</td>
                <td style="text-align:right;">{{helper.dateAndTime.getFourDigitTimeWithColon(departingFlight.destination.time)}}</td>
              </tr>    
              <tr v-if="returningFlight!=null&&returningFlight.stops>0"><td colspan="2">{{returningFlight.stops}} Stop(s)</td></tr>        
              <tr v-if="bagInfo!=null">
                <td colspan="2">
                  <SegmentBaggageInfo :segmentBagInfo="bagInfoDeparture"></SegmentBaggageInfo>
                </td>
              </tr>   
             
            </table>
            <br>
            <table v-if="returningFlight!=null" style="width:100%;">
              <tr><td colspan="2" style="font-weight:bold;">{{helper.dateAndTime.getDateText(returningFlight.origin.date)}}</td></tr>
              <tr>
                <td><span style="color:blue;font-weight:bold;">Airline: </span>{{returningFlight.airline + " (" + returningFlight.flightNo+")"}}</td>
              </tr>               
              <tr>
                <td>{{returningFlight.origin.airport.name + ' (' + returningFlight.origin.airport.code + ')'}}</td>
                <td style="text-align:right;">{{helper.dateAndTime.getFourDigitTimeWithColon(returningFlight.origin.time)}}</td>
              </tr>
              <tr>
                <td>{{returningFlight.destination.airport.name + ' (' + returningFlight.destination.airport.code + ')'}}</td>
                <td style="text-align:right;">{{helper.dateAndTime.getFourDigitTimeWithColon(returningFlight.destination.time)}}</td>
              </tr>                  
              <tr v-if="returningFlight!=null&&returningFlight.stops>0"><td colspan="2">{{returningFlight.stops}} Stop(s)</td></tr>   
              <tr v-if="bagInfo!=null">
                <td colspan="2">
                  <SegmentBaggageInfo :segmentBagInfo="bagInfoReturn"></SegmentBaggageInfo>
                </td>
              </tr>                                   
            </table>            
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import Theme from '../../theme';
import Helper from '../helper';
import SegmentBaggageInfo from '../CustomControls/SegmentBaggageInfo';

export default {
  props:[
    'flightDetails',
    'bagInfo',
    'flatBorder'
  ],
  created(){
    if (this.flatBorder!=null){
      this.useFlatBorder = this.flatBorder;
    }
  },
  computed:{
    bagInfoDeparture(){
      
      return this.getSegmentBagInfo(1,'D');
    },
    bagInfoReturn(){
      
      return this.getSegmentBagInfo(1,'R');
    },    
    departingFlight(){
      return this.flightDetails.flightsOfDeparture[0];
    },
    returningFlight(){
      return this.flightDetails.flightsOfReturn[0];
    },
    detpartingFlightStop(){
      return this.flightDetails.flightsOfDeparture.length-1;
    },
    returningFlightStop(){
      return this.flightDetails.flightsOfReturn.length-1;
    },
    isMobile(){
        return Helper.display.isMobile(this.$vuetify.breakpoint.name);
    },     
  },
  components:{
    SegmentBaggageInfo
  },
  methods:{
    getSegmentBagInfo(segNo,routing){
      
      let list = [];

      try {
        this.bagInfo.forEach((bg,index) => {
          let lnq = new this.$linq(bg.segments);
          let bgInf = lnq.where(b=>b.fareId==bg.fareId && b.routing==routing && b.segment==segNo).toArray()[0];

          bgInf.baggage = bgInf.bagInfo.split("-")[0];
          bgInf.carryOn = bgInf.bagInfo.split("-")[1];
          if (index==0){
            bgInf.pax="Adult";
          }else if (index==1) {
            bgInf.pax = "Child";
          }else {
            bgInf.pax = "Infant"
          }

          list.push(bgInf);
        });        
      } catch (error) {
        throw error
      }

      return list;      
    }
  },
  data(){
    return {
      theme:Theme,
      helper:Helper,
      useFlatBorder:false,
    }
  }
}
</script>

<style>

</style>